var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.783 18.318"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1ec584",
    d: "M6.795 18.322a2 2 0 0 1-1.517-.7l-4.796-5.6a2 2 0 0 1 3.035-2.6l3.135 3.661L16.56 1.135c1.534-2.148 3.139-.959 1.6 1.2L8.42 17.482a2 2 0 0 1-1.538.835z"
  })));
};
export default SvgCheckmark;